import { useAuth } from '../useAuth/useAuth'

import { isUsaCalifornia } from '@percent/utility'
import {
  getAccountConfigFromAuthState,
  getCountryCodeFromAuthState,
  getStateCodeFromAuthState
} from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'

export function useIsCaliforniaUser(): Readonly<boolean> {
  const authState = useAuth()
  const accountCountryCode = getCountryCodeFromAuthState(authState.state)
  const stateCode = getStateCodeFromAuthState(authState.state)
  const accConfig = getAccountConfigFromAuthState(authState.state)

  const userCountry = accConfig?.country || accountCountryCode
  const userStateProvince = accConfig?.stateProvince || stateCode

  return isUsaCalifornia(userCountry, userStateProvince)
}
